module.exports = __webpack_public_path__ + "img/teach.a9896be7.png";